<template>
  <div class="switchroom-monitoring dabg-box d-flex flex-column flex-grow-1">
    <div class="selector-container d-flex section-container" :class="{'dark':skinType}">
      <SectionTitle title="配电室监测"></SectionTitle>
      <project-level-selector
        @selectItem="selectItemListener"
        levelType="pds"
      ></project-level-selector>
    </div>
    <el-tabs type="border-card" class="flex-grow-1 d-flex flex-column section-container"
     :class="{'dark':skinType}">
      <el-tab-pane label="一次接线图">
        <room-primary
          :projectInfo="selectRoom"
          class="flex-grow-1"
        ></room-primary>
      </el-tab-pane>
      <el-tab-pane label="辅助监控">
        <el-row
          class="none-height flex-grow-1 justify-content-stretch"
          type="flex"
          align="center"
        >
          <el-col :span="24" class="d-flex flex-column">
            <el-table  size="small"
              height="0"
              class="flex-grow-1 section-container"
              :class="{'dark':skinType}"
              stripe
              border
              :data="monitoringData"
              :row-class-name="(...nu)=>{return skinType?'dark text-white':''}"
            >
              <el-table-column
                label="设备"
                prop="EquipmentName"
				align="center"
              ></el-table-column>
              <el-table-column
                label="属性"
				align="center"
                prop="PropertyName"
              >
				<template slot-scope="scope">
				  <span
				    class="iconfont zfcolor"
				    v-show="scope.row.PropertyName == '湿度'"
		  		    >&#xe642;
				  </span>
				  <span
				    class="iconfont zfcolor"
				    v-show="scope.row.PropertyName == '烟感告警'"
				    >&#xe654;
				  </span>
				  <span
				    class="iconfont zfcolor"
				    v-show="scope.row.PropertyName == '温度'"
				    >&#xe62e;</span
				  >
				  <span
				    class="iconfont zfcolor"
				    v-show="scope.row.PropertyName == '水浸告警'"
				    >&#xe654;</span
				  >
				  <span style="margin-left: 8px">{{
				    scope.row.PropertyName
				  }}</span>
				</template>
			  </el-table-column>
              <el-table-column
                label="值"
                prop="Value"
				align="center"
              >
                <template slot-scope="scope">
                  <el-tag
				  @click="tag_click(scope.row)"
                    size="mini"
                    :type="(scope.row.PropertyName.indexOf('告警') >= 0
                    &&scope.row.Value==0)||scope.row.PropertyName.indexOf('告警') < 0 ?
                     'primary' : 'warning'"
                    disable-transitions
                    >{{ (scope.row.PropertyName.indexOf('告警') >= 0&& scope.row.Value==0)?
                    "正常":(scope.row.PropertyName.indexOf("告警") == -1)
                     ? scope.row.Value:"告警" }}
                  </el-tag>
                </template>
              </el-table-column>
              <el-table-column label="时间" prop="Time" align="center"></el-table-column>
            </el-table>
          </el-col>

          <!-- <el-col
            :span="14"
            class="flex-grow-1 d-flex justify-content-center"
          >
            <Room class="flex-grow-1"></Room>
          </el-col> -->
        </el-row>
      </el-tab-pane>
    </el-tabs>
		<!-- 曲线图组件 按理来说这个组件应该是tabs组件的兄弟节点 -->
		<el-dialog
			diaId="video-dia"
			class="flex-grow-1"
			:visible.sync="dialog_monitoring_curve"
			:title="diaTitle"
			:class="{ dark: skinType }"
		>
			<monitoring-curve
				style="min-height: 400px"
				:equipType="equipType"
				:propInfo="propInfo"
				:equipmentInfo="selectEquipment"
			></monitoring-curve>
		</el-dialog>
  </div>
</template>
<script>
import monitoringCurve from "@/components/general/monitoring-curve.vue"; // 曲线弹窗
import roomPrimary from '@/components/svgs/room-primary.vue';
import ProjectLevelSelector from '@/components/utils/project-level-selector.vue';
import { getAuxiliaryMonitor } from '@/api/equipments/equipments';
import Room from '@/components/three-dismensional/room.vue';
import SectionTitle from '@/components/utils/section-title.vue';
import TurnAskingMixin from '@/mixins/turn-ask';
import iconfont from '@/assets/fonts/iconfont/iconfont.css';

export default {
  mixins: [TurnAskingMixin],
  components: {
    roomPrimary,
    ProjectLevelSelector,
    Room,
    SectionTitle,
	monitoringCurve
  },
  data() {
    return {
	  propInfo:null,
	  diaTitle:'',
	  equipType:null,
	  selectEquipment:null,
	  dialog_monitoring_curve: false, 
	  roomList: null,
	  selectRoom: null,
	  state: false,
	  monitoringData: [],
    };
  },
  created() {
    this.requestEquipmentTree();
  },
  watch: {
    selectRoom() {
      this.requestAuxiliaryMonitor();
    },
    projectList(newVal) {
      this.roomList = this.getRoomList(newVal);
    },
  },
  computed: {
    projectList() {
      return this.$store.getters.projectList;
    },
    skinType() {
      return this.$store.getters.skinType;item
    },
  },
  methods: {
		// 点击值时
		tag_click(item) {
			console.log('22222')
			if(item.EPType==2){
				this.open_details(item);
			} else {
				this.$message({
				  message: '提示: 暂无数据',
				  type: 'warning'
				});
			}
			
		},
		// 用以直接打开折线图组件
		open_details(item) {
			console.log('111----------->',item);
			// isCal
			this.propInfo = item;
			this.diaTitle = item.EquipmentName;
			this.equipType = item.PropertyID;
			this.selectEquipment = {
				SBMName: item.EquipmentName,
				TabIDstr: item.EquipmentIDStr,
				// TabID: 233797,
			};
			this.$nextTick(() => {
				this.dialog_monitoring_curve = true;
			});
		},
    requestAuxiliaryMonitor() {
      if (this.selectRoom == null) {
        this.monitoringData = [];
        return;
      }
      getAuxiliaryMonitor({
        StationIDstr: this.selectRoom.IdStr,
      }).then((res) => {
        this.monitoringData = res;
      }).catch(() => {
        this.monitoringData = [];
      }).then(() => {
        this.turnAsking({
          routeName: this.routeName,
          nowRouteName: this.$route.name,
          func: this.requestAuxiliaryMonitor,
        }, 5000);
      });
    },
    selectItemListener(selectItem) {
      if (selectItem.oType === 'pds') {
        this.selectRoom = selectItem;
      }
    },
    requestEquipmentTree() {
      if (this.projectList !== null) {
        this.roomList = this.getRoomList(this.projectList);
        return;
      }
      this.$store.dispatch('projects/projectList', { level: 1 });
    },
    getRoomList(res) {
      const arr = [];
      for (let i = 0; i < res.length; i += 1) {
        const nodeInfo = res[i];
        if (this.nodeHasRoom(nodeInfo)) {
          arr.push(nodeInfo);
        }
      }
      return arr;
    },
    nodeHasRoom(nodeInfo) {
      if (nodeInfo.oType === 'pds') {
        return true;
      }
      if (!nodeInfo.Children) {
        return false;
      }
      for (let i = 0; i < nodeInfo.Children.length; i += 1) {
        const childInfo = nodeInfo.Children[i];
        if (this.nodeHasRoom(childInfo)) {
          return true;
        }
      }
      return false;
    },
  },
};
</script>
<style scoped>
	 .zfcolor {
	   color: #66b1ff;
	 }
</style>
